export default __webpack_public_path__ + "static/media/middle_flow_bubble_list.85677b99.png";